export const TOLERANCE_OPTIONS = [
  { value: 'Zero(0)', label: 'Zero(0)' },
  { value: '+-3%', label: '±3%' },
  { value: '+-5%', label: '±5%' },
  { value: '+-7%', label: '±7%' },
  { value: '+-10%', label: '±10%' },
  { value: '+3%', label: '+3%' },
  { value: '+5%', label: '+5%' },
  { value: '+7%', label: '+7%' },
  { value: '+10%', label: '+10%' },
  { value: '-3%', label: '-3%' },
  { value: '-5%', label: '-5%' },
  { value: '-7%', label: '-7%' },
  { value: '-10%', label: '-10%' },
];